module.exports = __webpack_public_path__ + "img/phone.48f172a0.svg";